import { makeI18n } from '@/shared/lib/i18n';
import lang from '../assets/freebusy.lang.json';

export const i18nLocal = makeI18n(lang);
